module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAWCAYAAADeiIy1AAABQklEQVR4AexVsUrDYBD+7jcpDg4+giCCkDxChwz6AA7uhcZJBQfdHNydxLEp9QEc3C3Yh0i3PoKDoFBNiucdJL9S/G1TCDjkuOO+3H/3feQI+c20s7uVxeGTRC7Bjnj96IbXHMFDYYqzo+A26wZTx4xyKeejapg1z+vJbCRhSQTP+wYRzvPt8Lg8yHcEM52AaL2s/ZKVc080BkYOVUTSYifA9hJzG8tbW4VUdfmRspOpypynQuVorbkRWnm9zeqa1dkN/M+PgQmbKOwnLkp/pqpvFGVx0JOrYSCs9gcreKFXFRJCiuVq6Aio5CsIVeK3zQbM7/apNsBvRtZwVxv/N3Fi/El6CsYZge+J8eAKAEOJeR+6+su6cvuT8YWhEWatfnrjJ+NDv58euKKVpPsEXMrgC8DP/Ikrrbn6y7py0wizLwAAAP//GN49KwAAAAZJREFUAwD5GqIli4geyQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/learningCenter.png
// module id = sMZO
// module chunks = 20